export default {
  difficulty: null,
  __typename: 'DifficultyOfDietary'
};
